import React, { createContext, useState } from "react";
import {Entry} from "@bloonde/cms/cms-entries/models/Entry";

interface CreateActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;  
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: Entry;
  setElement: (element: any) => void;
  selectedLang: string;
  setSelectedLang: (selectedLang: string) => void;
}

export const CreateActionContext = createContext<CreateActionContextType>({  
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  showModal: false,
  setShowModal: () => {},
  element: new Entry(),
  setElement: () => {},
  selectedLang: "",
  setSelectedLang: () => {},
});

interface CreateActionProviderProps {
  children: React.ReactNode;
}

export const CreateActionProvider: React.FC<CreateActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(new Entry());
  const [selectedLang, setSelectedLang] = useState<string>("");

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    showModal,
    setShowModal,
    element,
    setElement,
    selectedLang,
    setSelectedLang,
  };
  return (
    <CreateActionContext.Provider value={value}>
      {children}
    </CreateActionContext.Provider>
  );
};
